import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useEffect } from "react";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import DownloadFieldByPdfLink from "../../unit/DownloadFieldByPdfLink";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import useNotify from "../../unit/useNotify";
import CustomPaymentRefundDialog from "../actions/CustomPaymentRefundDialog";
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoadCurrentPaymentRecord = ({ ...props }) => {
  const data = props.data;
  // console.log("data in LoadCurrentPaymentRecord", data);
  const appId = props.appId;
  let paymentNumber = 0;
  return (
    <React.Fragment key={`currepntpayment_pp${appId}`}>
      {data.map((item: any, idx: number) => (
        <React.Fragment key={`currepntpayment_${item.iId || item.id || idx}`}>
          {item.type == "payment" && (
            <CustomCurrentPaymentRecord
              item={item}
              // key={`paymentRecord_` + item.iId}
              key={`paymentRecord_` + idx}
              appId={appId}
              paymentNumber={++paymentNumber}
            />
          )}
          {item.type == "modify" && (
            <CustomModifyRecord
              item={item}
              // key={`modifyRecord_` + item.id}
              key={`modifyRecord_` + idx}
              appId={appId}
            />
          )}
          {item.type == "payfaster" && (
            <CustomPayfasterRecord
              item={item}
              // key={`payfasterRecord_` + item.id}
              key={`payfasterRecord_` + idx}
              appId={appId}
            />
          )}
          {item.type == "modify_reduce_payment" && (
            <CustomModifyReduceRecord
              item={item}
              // key={`modifyRecord_` + item.id}
              key={`modifyRecord_` + idx}
              appId={appId}
            />
          )}
          {item.type == "modify_skip_payment" && (
            <CustomModifySkipRecord
              item={item}
              // key={`modifyRecord_` + item.id}
              key={`modifyRecord_` + idx}
              appId={appId}
            />
          )}
          {item.type == "modify_postpone_payment" && (
            <CustomModifyPostponeRecord
              item={item}
              // key={`modifyRecord_` + item.id}
              key={`modifyRecord_` + idx}
              appId={appId}
            />
          )}
          {item?.type != "payment" &&
            item?.type != "modify" &&
            item?.type != "payfaster" &&
            item?.type != "modify_reduce_payment" &&
            item?.type != "modify_postpone_payment" &&
            item?.type != "modify_skip_payment" && (
              <TableRow key={`otherRecord_` + idx}>
                <TableCell colSpan={18} sx={{ background: "#cdb6ec" }}>
                  <Typography variant="body2" sx={{ cursor: "pointer" }}>
                    &nbsp;
                  </Typography>
                </TableCell>
              </TableRow>
            )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};
const CustomCurrentPaymentRecord = ({ ...props }) => {
  const [open, setOpen] = React.useState(false);

  const item = props.item;
  const appId = props.appId;
  const paymentNumber = props.paymentNumber;
  const row = props.item;
  const showPaymentDetail = false;

  const toNumber = (value: any) => {
    const parsedValue = Number(value);

    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };

  function showActualLoanBalance(
    status: string,
    actualLoanBalance: number,
    actualAmountPaid: number
  ) {
    //  {item.sStatus == "success" || item.dActualAmountPaid > 0
    //             ? formatCurrency(item.dActualLoanBalance)
    //             : null}
    //           {item?.sStatus == "expired" && item.dActualLoanBalance
    //             ? formatCurrency(item.dActualLoanBalance)
    //             : null}
    //           {item?.sStatus == "failed" && item.dActualLoanBalance
    //             ? formatCurrency(item.dActualLoanBalance)
    //       : null
    //     }
    if (actualAmountPaid) {
      // if (
      //   status == "success" ||
      //   status == "succeed" ||
      //   status == "expired" ||
      //   status == "failed"
      // ) {
      return formatCurrency(actualLoanBalance);
      // } else {
      //   return null;
      // }
    } else {
      if (status == "expired" || status == "failed") {
        return formatCurrency(actualLoanBalance);
      } else {
        return null;
      }
    }
  }
  return (
    <>
      <TableRow key={`payment_` + item.iId}>
        {showPaymentDetail && (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )}
        <TableCell>{paymentNumber}</TableCell>
        <TableCell
          className="numericText"
          sx={{ minWidth: "180px", whiteSpace: "nowrap" }}
        >
          {formatDate(item.dPaymentDate)}

          {item?.invoice_pdf_name && item?.invoice_pdf_link != "" && (
            <DownloadFieldByPdfLink
              linktoken={item.invoice_pdf_link}
              filename={item.invoice_pdf_name}
              sx={{ fontSize: "1.2rem", verticalAlign: "middle" }}
            />
          )}
        </TableCell>
        <TableCell className="amountText">
          {formatCurrency(item.paymentAmount)}
        </TableCell>
        <TableCell className="amountText">
          {formatCurrency(item.dOriginalInvoiceAmount)}
        </TableCell>
        <TableCell className="dateText">
          {item.dLastActualPaidDate != "0000-00-00 00:00:00"
            ? formatDate(item.dLastActualPaidDate)
            : ""}
        </TableCell>
        <TableCell className="amountText">
          {item.dActualAmountPaid > 0
            ? formatCurrency(item.dActualAmountPaid)
            : ""}
        </TableCell>
        <TableCell className="amountText" align="right">
          {new Date() >= new Date(item.dPaymentDate) ||
          item.dActualAmountPaid > 0
            ? item.dOriginalInvoiceAmount - item.dActualAmountPaid > 0
              ? formatCurrency(
                  item?.dActualLoanBalance == 0
                    ? 0
                    : item.dOriginalInvoiceAmount - item.dActualAmountPaid
                )
              : formatCurrency(0)
            : ""}
        </TableCell>
        <TableCell className="amountText">
          {item.sStatus == "success" || item.dActualAmountPaid > 0
            ? formatCurrency(
                item.interestAmountPaid > 0
                  ? item.interestAmountPaid
                  : item.interestAmount
              )
            : null}
          {/* <>
            {item.sStatus == "success" || item.dActualAmountPaid > 0
              ? formatCurrency(item.dActualAmountPaid - item.principalReduction)
              : null}
          </> */}
        </TableCell>
        {/* Interest Past Due */}
        {/* <TableCell className="amountText">
          {item.sStatus == "expired" || item.sStatus == "failed"
            ? formatCurrency(item.dInterestPastDueSum)
            : null}
        </TableCell> */}
        <TableCell className="amountText" align="right">
          {item?.dActualLoanBalance < 0 ? (
            <>
              {item.sStatus == "success" || item.dActualAmountPaid > 0
                ? formatCurrency(
                    Math.abs(item.principalReduction) +
                      Math.abs(item?.dActualLoanBalance ?? 0)
                  )
                : null}
            </>
          ) : (
            <>
              {item.sStatus == "success" || item.dActualAmountPaid > 0
                ? formatCurrency(item.principalReduction)
                : null}
            </>
          )}
        </TableCell>
        <TableCell className="amountText">
          {showActualLoanBalance(
            item?.sStatus,
            item.dActualLoanBalance,
            item?.dActualAmountPaid
          )}
        </TableCell>
        <TableCell className="numericText" sx={{ textAlign: "right" }}>
          {/* {item.sStatus == "expired" && item?.iDaysPastDue > 0
            ? item.iDaysPastDue
            : null} */}
          {item.sStatus == "expired" && item?.daysPast > 0
            ? item.daysPast
            : null}
        </TableCell>
        <TableCell className="dateText">
          {item.dAmountPastDue > 0 ? formatCurrency(item.dAmountPastDue) : ""}
        </TableCell>
        <TableCell className="amountText">
          {item?.dLateFees > 0 ? formatCurrency(item.dLateFees) : ""}
        </TableCell>
        <TableCell className="numericText">{item.iId}</TableCell>
      </TableRow>
      {showPaymentDetail && (
        <TableRow>
          <TableCell
            style={{ margin: 0, padding: 0, width: "100%" }}
            colSpan={10}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 0, padding: 0, mt: 1, mb: 1 }}>
                <Table
                  size="small"
                  aria-label="actualpaymenthistory"
                  sx={{ margin: 0, padding: 0, width: "100%" }}
                >
                  <TableBody sx={{ margin: 0, padding: 0, width: "100%" }}>
                    {/* {row.history.map((historyRow: any) => ( */}
                    <TableRow
                      key={`historyRow_` + item.iId}
                      sx={{
                        margin: 0,
                        padding: 0,
                        width: "100%",
                      }}
                    >
                      <TableCell sx={{ border: "none" }}></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ minWidth: "150px", border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell sx={{ background: "#e2efda" }}>
                        Actual Payment Date
                      </TableCell>
                      <TableCell sx={{ background: "#e2efda" }}>
                        Actual Payment Amount
                      </TableCell>
                      <TableCell sx={{ background: "#e2efda" }}></TableCell>
                      <TableCell sx={{ background: "#e2efda" }}>
                        Interest Paid
                      </TableCell>
                      <TableCell sx={{ background: "#e2efda" }}>
                        Principal Paid
                      </TableCell>
                      <TableCell sx={{ background: "#e2efda" }}>
                        Remaining Principal Balance
                      </TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="dateText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                    </TableRow>
                    {/* <TableRow
                      key={`historyRow_` + item.iId}
                      sx={{ margin: 0, padding: 0, width: "100%" }}
                    >
                      <TableCell sx={{ border: "none" }}></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ minWidth: "150px", border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell className="dateText">
                        {" "}
                        {item.dLastActualPaidDate != "0000-00-00 00:00:00"
                          ? formatDate(item.dLastActualPaidDate)
                          : ""}
                      </TableCell>
                      <TableCell className="amountText">
                        {item.dActualAmountPaid > 0
                          ? formatCurrency(item.dActualAmountPaid)
                          : ""}
                      </TableCell>
                      <TableCell className="dateText"></TableCell>
                      <TableCell className="amountText">
                        {item.status == "success" || item.dActualAmountPaid > 0
                          ? formatCurrency(item.interestAmount)
                          : null}
                      </TableCell>
                      <TableCell className="amountText">
                        {item.status == "success" || item.dActualAmountPaid > 0
                          ? formatCurrency(item.principalReduction)
                          : null}
                      </TableCell>
                      <TableCell className="amountText">
                        {item.status == "success" || item.dActualAmountPaid > 0
                          ? formatCurrency(item.dActualLoanBalance)
                          : null}
                      </TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="dateText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                    </TableRow> */}
                    {/* <TableRow
                      key={`historyRow_` + item.iId}
                      sx={{ margin: 0, padding: 0, width: "100%" }}
                    >
                      <TableCell sx={{ border: "none" }}></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ minWidth: "150px", border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell className="dateText">{"2024-12-13"}</TableCell>
                      <TableCell className="amountText">$400</TableCell>
                      <TableCell className="dateText"></TableCell>
                      <TableCell className="amountText">$400</TableCell>
                      <TableCell className="amountText">$0</TableCell>
                      <TableCell className="amountText">$19415.92</TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="dateText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                    </TableRow>
                    <TableRow
                      key={`historyRow_` + item.iId}
                      sx={{ margin: 0, padding: 0, width: "100%" }}
                    >
                      <TableCell sx={{ border: "none" }}></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ minWidth: "150px", border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell className="dateText">{"2024-12-17"}</TableCell>
                      <TableCell className="amountText">$400</TableCell>
                      <TableCell className="dateText"></TableCell>
                      <TableCell className="amountText">$26.30</TableCell>
                      <TableCell className="amountText">$373.70</TableCell>
                      <TableCell className="amountText">$19042.22</TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="dateText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="amountText"
                        sx={{ border: "none" }}
                      ></TableCell>
                      <TableCell
                        className="numericText"
                        sx={{ border: "none" }}
                      ></TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

const CustomModifyRecord = ({ ...props }) => {
  const item = props.item;
  const handleOpenModifyPage = () => {
    document
      .querySelector(
        "#loan-summary-tab-body-" + props?.appId + " #btn-show-tab-loanmodify"
      )
      ?.click();
  };
  return (
    <TableRow key={`modify_` + item.id}>
      <TableCell colSpan={18} sx={{ background: "#fffcd0" }}>
        <Typography
          variant="body2"
          onClick={handleOpenModifyPage}
          sx={{ cursor: "pointer" }}
        >
          Modify Loan Terms (
          <span className="numericText">{item.created_at}</span>)
        </Typography>
      </TableCell>
    </TableRow>
  );
};
const CustomModifyReduceRecord = ({ ...props }) => {
  const item = props.item;
  // const handleOpenModifyPage = () => {
  //   document
  //     .querySelector(
  //       "#loan-summary-tab-body-" + props?.appId + " #btn-show-tab-loanmodify"
  //     )
  //     ?.click();
  // };
  return (
    <TableRow key={`modify_` + item.id}>
      <TableCell colSpan={18} sx={{ background: "#fffcd0" }}>
        <Typography
          variant="body2"
          // onClick={handleOpenModifyPage}
          // sx={{ cursor: "pointer" }}
        >
          Reduce Select Payments (
          <span className="numericText">{item.created_at}</span>)
        </Typography>
      </TableCell>
    </TableRow>
  );
};
const CustomModifySkipRecord = ({ ...props }) => {
  const item = props.item;
  // const handleOpenModifyPage = () => {
  //   document
  //     .querySelector(
  //       "#loan-summary-tab-body-" + props?.appId + " #btn-show-tab-loanmodify"
  //     )
  //     ?.click();
  // };
  return (
    <TableRow key={`modify_` + item.id}>
      <TableCell colSpan={18} sx={{ background: "#fffcd0" }}>
        <Typography
          variant="body2"
          // onClick={handleOpenModifyPage}
          // sx={{ cursor: "pointer" }}
        >
          Skip Upcoming Payment (
          <span className="numericText">{item.created_at}</span>)
        </Typography>
      </TableCell>
    </TableRow>
  );
};
const CustomModifyPostponeRecord = ({ ...props }) => {
  const item = props.item;
  return (
    <TableRow key={`modify_` + item.id}>
      <TableCell colSpan={18} sx={{ background: "#fffcd0" }}>
        <Typography variant="body2">
          Postpone Next Payment (
          <span className="numericText">{item.created_at}</span>)
        </Typography>
      </TableCell>
    </TableRow>
  );
};
const CustomPayfasterRecord = ({ ...props }) => {
  const item = props.item;

  return (
    <TableRow key={`payfaster_` + item.id} sx={{ background: "#e9ffee" }}>
      <TableCell colSpan={4}>
        <Typography variant="body2" sx={{ cursor: "pointer" }}>
          Payfaster (
          <span className="numericText">{formatDate(item.created_at)}</span>)
        </Typography>
      </TableCell>
      <TableCell>{formatDate(item?.dActualPaymentDate)}</TableCell>
      <TableCell
        align="right"
        className="hm-table-header"
        sx={{
          "&.MuiTableCell-head": {
            width: "110px !important",
            maxWidth: "110px",
            minWidth: "110px",
          },
        }}
      >
        {formatCurrency(item?.iActualPaymentAmount)}
      </TableCell>
      <TableCell>&nbsp;</TableCell>
      <TableCell
        align="right"
        className="hm-table-header"
        sx={{
          "&.MuiTableCell-head": {
            width: "110px !important",
            maxWidth: "110px",
            minWidth: "110px",
          },
        }}
      >
        {formatCurrency(item?.interestAmount)}
      </TableCell>
      <TableCell
        align="right"
        className="hm-table-header"
        sx={{
          "&.MuiTableCell-head": {
            width: "110px !important",
            maxWidth: "110px",
            minWidth: "110px",
          },
        }}
      >
        {formatCurrency(item?.principalReduction)}
      </TableCell>
      <TableCell
        align="right"
        className="hm-table-header"
        sx={{
          "&.MuiTableCell-head": {
            width: "110px !important",
            maxWidth: "110px",
            minWidth: "110px",
          },
        }}
      >
        {formatCurrency(item?.dActualLoanBalance)}
      </TableCell>
      <TableCell colSpan={4}>&nbsp;</TableCell>
    </TableRow>
  );
};

const LoanCurrentPayment = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const [paymentData, setPaymentData] = React.useState<any>(null);
  const { data, isPending, isFetching, error } = useGetOne(
    "loan/paymentschedule/current",
    {
      id: appId,
    }
  );
  useEffect(() => {
    setPaymentData(data);
  }, [data]);

  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  // if (isPending) return <CustomMessage>Loading...</CustomMessage>;
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!paymentData)
    return <CustomMessage message="No paymentdata found for this id" />;

  const currentList = paymentData ? paymentData.data : [];
  let currentList2 = Object.keys(currentList)
    .map((key) => {
      return currentList[key].map((item: { type: string; data: any }) => {
        // item.data.iId = item.data.iId;
        // console.log("item in currentList2 map", item?.type);
        return item.data;
      });
    })
    .flat();

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          stickyHeader
          id="table-loan-summary-current-schedule-list"
          sx={{ tableLayout: "fixed" }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  "&.MuiTableCell-head": {
                    width: "105px !important",
                    maxWidth: "105px",
                    minWidth: "105px",
                  },
                }}
                className="hm-table-header"
              >
                Payment #
              </TableCell>
              <TableCell
                sx={{
                  "&.MuiTableCell-head": {
                    width: "135px !important",
                    maxWidth: "135px",
                    minWidth: "135px",
                  },
                }}
                className="hm-table-header"
              >
                Payment <br />
                Due Date
              </TableCell>
              <TableCell
                align="right"
                className="hm-table-header"
                sx={{
                  "&.MuiTableCell-head": {
                    width: "110px !important",
                    maxWidth: "110px",
                    minWidth: "110px",
                  },
                }}
              >
                Scheduled Payment Amount
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Invoice Amount
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Actual <br />
                Payment
                <br /> Date
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Actual Payment Amount
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Unpaid Balance
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Interest Paid
              </TableCell>
              {/* <TableCell align="right" className="hm-table-header">
                Interest Past Due
              </TableCell> */}
              <TableCell align="right" className="hm-table-header">
                Principal Paid
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Remaining Principal Balance
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Days Past Due
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Amount Past Due
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Late Fees
              </TableCell>
              <TableCell align="left" className="hm-table-header">
                Payment ID
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentList2 == undefined ||
            currentList2.length == 0 ||
            currentList2 == null ? (
              <TableRow>
                <TableCell colSpan={8}>
                  {/* Missing Payment ID, Please click "Modify Loan Terms" */}
                  {/* 当前没有可用的payment */}
                  There is no current payment record available.
                </TableCell>
              </TableRow>
            ) : (
              <LoadCurrentPaymentRecord data={currentList2} appId={appId} />
            )}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanCurrentPayment;
